import { ofetch } from 'https://cdn.jsdelivr.net/npm/ofetch/+esm'
import Cookies from 'https://cdn.jsdelivr.net/npm/universal-cookie@8.0.1/+esm'

const cookies = new Cookies(null, { path: '/', domain: location.hostname })
const baseApi = 'https://account.momcozy.com'

const COOKIE_KEY = 'momcozy-token'
export const request = ofetch.create({
  method: 'POST',
  baseURL: baseApi,
  onRequest({ options }) {
    const token = cookies.get(COOKIE_KEY)
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }
  },
  onResponse(res) {
    const data = res.response._data
    if (data && data.code === '200') {
      res.response._data = data.result || data.data || true
      return
    }

    if (data?.code === '10001003') document.dispatchEvent(new CustomEvent('lute:account:logout'))

    Object.assign(res, {
      response: {
        status: 400,
        message: data?.message || 'Network error',
        ...res.response,
      },
    })
  },
})

export let userInfo = null
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('lute:account:logout', () => {
    cookies.remove(COOKIE_KEY)
  })

  document.addEventListener('lute:account', function (e) {
    const accountEl = document.querySelector('.t4s-site-nav__account')
    accountEl.classList.add('logined')
    accountEl.querySelector('.t4s-my-account').remove()
  })

  getUserInfo().then(res => {
    userInfo = res
    if (res) {
      document.dispatchEvent(
        new CustomEvent('lute:account', { detail: { type: 'keep', email: res.email } })
      )
    }
  })
})

function setToken(token) {
  cookies.set(COOKIE_KEY, token, { maxAge: 7 * 24 * 60 * 60 })
}

export async function getUserInfo() {
  const token = cookies.get(COOKIE_KEY)
  if (!token) return null
  const res = await request('/api/station/user/getUserInfo', { method: 'get' })
  return res
}

function encodeToBase64(str) {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  let binaryString = ''
  for (let i = 0; i < data.length; i++) {
    binaryString += String.fromCharCode(data[i])
  }
  return btoa(binaryString)
}

function isValidEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

const accountHtml = `<form
  is="login-form"
  novalidate
  class="login-modal"
>
  <div class="header">
    <h4>Sign In</h4>
  </div>
  <div class="form">
    <div class="form-item">
      <input
        type="email"
        placeholder="Email"
        required
      >
    </div>
    <div class="form-item">
      <input
        type="password"
        placeholder="Passwords"
        required
      >
    </div>
    <div class="btns">
      <button class="submit-btn" type="submit">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity=".5"/><path fill="currentColor" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"></path>
        </svg>
        Sign in
      </button>
    </div>
  </div>
  <div class="toggle">
    New customer?
    <button type="button">Create an account</button>
  </div>
</form>
<form
  is="register-form"
  novalidate
  class="register-modal"
>
  <div class="header">
    <h4>Create Account</h4>
  </div>
  <div class="form">
    <div class="form-item">
      <input
        type="email"
        placeholder="Email"
        required
      >
    </div>
    <div class="form-item">
      <input
        type="password"
        placeholder="Passwords"
        required
      >
    </div>
    <div class="btns">
      <button class="submit-btn" type="submit">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity=".5"/><path fill="currentColor" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"></path>
        </svg>
        Sign up
      </button>
    </div>
  </div>
  <div class="toggle">
    Already have an account?
    <button type="button">Sign in</button>
  </div>
</form>`

class LoginModal extends HTMLElement {
  constructor() {
    super()
    this.customClass = this.dataset.customClass
    this.modal = null
  }

  connectedCallback() {
    const htmlCtx = new DOMParser().parseFromString(accountHtml, 'text/html')
    this.loginModal = htmlCtx.querySelector('.login-modal')
    this.registerModal = htmlCtx.querySelector('.register-modal')
    this.type = ''

    this.registerEvent()
  }

  registerEvent() {
    this.addEventListener('click', this.onClick.bind(this))
  }

  loadScript() {
    return new Promise(resolve => {
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/tingle.js/dist/tingle.min.js'
      script.onload = resolve
      document.head.appendChild(script)
    })
  }

  loadStyle() {
    return new Promise(resolve => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://cdn.jsdelivr.net/npm/tingle.js/dist/tingle.min.css'
      link.onload = resolve
      document.head.appendChild(link)
    })
  }

  loadSource() {
    return Promise.all([this.loadStyle(), this.loadScript()])
  }

  initPopup(customClass, config = {}) {
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass, customClass],
      ...config,
    })
    this.toggleModal()
    this.onOpen()
  }

  onOpen() {
    this.modal.open()
  }

  onClose() {
    this.modal.close()
  }

  toggleModal() {
    if (this.type === 'login') {
      this.type = 'register'
      this.modal.setContent(this.registerModal)
    } else {
      this.type = 'login'
      this.modal.setContent(this.loginModal)
    }
  }

  async onClick() {
    const res = await getUserInfo()
    // 已登录
    if (res) {
      document.dispatchEvent(new CustomEvent('lute:account', { detail: { type: 'click' } }))
      return
    }
    if (!this.modal) {
      await this.loadSource()
      this.initPopup('account-modal')
    } else {
      this.onOpen()
    }
  }
}
customElements.define('login-modal', LoginModal)

class AccountForm extends HTMLFormElement {
  constructor() {
    super()
    this.emailEl = this.querySelector('input[type="email"]')
    this.passwordEl = this.querySelector('input[type="password"]')
    this.loginModal = document.querySelector('login-modal')
    this.toggleModal = this.toggleModalFn.bind(this)
  }

  connectedCallback() {
    this.registerEvent()
  }

  disconnectedCallback() {
    this.unregisterEvent()
  }

  registerEvent() {
    this.emailEl.addEventListener('input', this.removeError)
    this.passwordEl.addEventListener('input', this.removeError)
    this.addEventListener('submit', this.onSubmit)
    this.querySelector('.toggle button')?.addEventListener('click', this.toggleModal)
  }

  unregisterEvent() {
    this.querySelector('.toggle button')?.removeEventListener('click', this.toggleModal)
    this.emailEl.removeEventListener('input', this.removeError)
    this.removeEventListener('submit', this.onSubmit)
  }

  removeError() {
    const errorTips = this.querySelectorAll('.error-tips')
    if (errorTips.length) errorTips.forEach(tip => tip.remove())
  }

  toggleModalFn() {
    if (this.loginModal) this.loginModal.toggleModal()
  }

  closeModal() {
    if (this.loginModal) this.loginModal.onClose()
  }

  createError(msg, inputEl) {
    const el = document.createElement('div')
    el.classList.add('error-tips')
    el.innerText = msg
    inputEl.parentNode.appendChild(el)
  }

  validate() {
    const email = this.emailEl.value.trim()
    const password = this.passwordEl.value.trim()
    const errors = {
      email: [],
      password: [],
    }
    if (!email) {
      this.createError('Please enter your email address', this.emailEl)
      errors.email.push('Email is empty')
    }
    if (email && !isValidEmail(email)) {
      this.createError('Please enter a valid email address', this.emailEl)
      errors.email.push('Email is invalid')
    }
    if (!password) {
      this.createError('Please enter your password', this.passwordEl)
      errors.password.push('Password is empty')
    }
    if (password && (password.length < 6 || password.length > 20)) {
      this.createError('Password must be between 6 and 20 characters', this.passwordEl)
      errors.password.push('Password length is invalid')
    }

    if (errors.email.length || errors.password.length) {
      throw new Error('Validation failed')
    }
  }

  toggleBtn() {
    const btn = this.querySelector('.btns .submit-btn')
    const isDisabled = btn.getAttribute('disabled')
    isDisabled ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', 'disabled')
  }
}

class LoginForm extends AccountForm {
  constructor() {
    super()
  }

  async login() {
    try {
      const email = this.emailEl.value.trim()
      const password = this.passwordEl.value.trim()
      const data = {
        email: email,
        platForm: 'SHOPIFY',
        subscribeNews: 0,
        firstName: '',
        lastName: '',
        password: encodeToBase64(password),
      }
      const res = await request('/api/station/user/login', { body: data })
      return res
    } catch (e) {
      this.createError(e.response?.message || 'Network error', this.passwordEl)
      throw new Error('Login failed')
    }
  }

  async onSubmit(e) {
    e.preventDefault()
    try {
      this.toggleBtn()
      this.removeError()
      this.validate()
      const res = await this.login()
      setToken(res.token)

      document.dispatchEvent(
        new CustomEvent('lute:account', {
          detail: { type: 'login', email: this.emailEl.value.trim(), token: res.token },
        })
      )
      this.closeModal()
    } catch (error) {
      console.error(error)
    } finally {
      this.toggleBtn()
    }
  }
}
customElements.define('login-form', LoginForm, { extends: 'form' })

class RegisterForm extends AccountForm {
  constructor() {
    super()
  }

  async register() {
    try {
      const email = this.emailEl.value.trim()
      const password = this.passwordEl.value.trim()
      const data = {
        email: email,
        platForm: 'SHOPIFY',
        subscribeNews: 0,
        firstName: '',
        lastName: '',
        password: encodeToBase64(password),
        registerSource: 'momcozy_login',
        registerChannel: 'station',
      }
      const res = await request('/api/station/user/register', { body: data })
      return res
    } catch (e) {
      this.createError(e.response?.message || 'Network error', this.passwordEl)
      throw new Error('Login failed')
    }
  }

  genJumpMsg(seconds) {
    const el = document.createElement('div')
    el.classList.add('error-tips')
    function setHtml(seconds) {
      el.innerHTML = `A verification email has been sent to your mailbox, please go to verify your account. Redirecting to <button class="to-sign" type="button">login in </button> ${seconds} seconds...`
    }
    let times = null

    el.addEventListener('click', () => {
      clearInterval(times)
      this.toggleModal()
      el.remove()
    })
    setHtml(seconds)
    this.passwordEl.parentNode.appendChild(el)

    times = setInterval(() => {
      seconds--
      setHtml(seconds)

      if (seconds <= 0) {
        clearInterval(times)
        el.remove()
        this.toggleModal()
      }
    }, 1000)
  }

  async onSubmit(e) {
    e.preventDefault()
    try {
      this.toggleBtn()
      this.removeError()
      this.validate()
      await this.register()
      this.genJumpMsg(3)
    } catch (error) {
      console.error(error)
    } finally {
      this.toggleBtn()
    }
  }
}
customElements.define('register-form', RegisterForm, { extends: 'form' })
